<script setup lang='ts'>
import Checkbox from './Checkbox.vue'
import type { IssueItem } from '~/logic/common/issue'

const props = withDefaults(defineProps<{
  issues: IssueItem[]
  modelValue: string[]
  carSeriesEnergyCode?: string
}>(), {

})
const emits = defineEmits({
  'update:modelValue': (_value: string[]) => true,
})

function changeItem(value: string) {
  const newValues = [...props.modelValue]
  const splitArr = value.split('-')
  const index = props.modelValue.findIndex(v => v.split('-')[1] === splitArr[1])
  if (index === -1) {
    newValues.push(value)
  }
  else if (splitArr.length === 1) {
    newValues.splice(index, 1)
  }
  else {
    const current = props.modelValue[index]
    if (current === value)
      newValues.splice(index, 1)
    else
      newValues.splice(index, 1, value)
  }

  emits('update:modelValue', newValues)
}

const idToLabel = computed(() => {
  const obj: Record<string, string> = {}
  for (const v of props.issues) {
    obj[v.value] = v.label
    if (!v.children || !v.children.length)
      continue
    for (const vv of v.children)
      obj[vv.value] = vv.label
  }
  return obj
})
const selectedLabels = computed(() => {
  const arr: string[] = []
  for (const v of props.modelValue) {
    const splitArr = v?.split('-')
    const issueId = splitArr[1]
    const label = idToLabel.value[issueId]
    if (!label)
      continue
    if (splitArr.length === 2) {
      arr.push(label)
      continue
    }
    if (splitArr && splitArr[3])
      arr.push(`${label}-${splitArr[3]}`)
  }
  return arr
})
</script>

<template>
  <div v-if="issues.length" class="rounded-md overflow-hidden w-full border-1 border-slate-2">
    <!-- {{ carSeriesEnergyCode }} -->
    <!-- {{ modelValue }} -->
    <NTabs class="tab overflow-hidden" type="line" :default-value="issues[0].value">
      <template v-for="(v, i) in issues" :key="i">
        <NTabPane :tab="v.label" :name="v.value">
          <div class="px-sm flex flex-wrap">
            <Checkbox
              v-for="item, index in v.children?.filter(s => !s.energyType || !carSeriesEnergyCode || carSeriesEnergyCode === '3' || (s.energyType == carSeriesEnergyCode))"
              :key="index"
              :fid="v.value"
              :parts-classz-id="item.partsClasszId"
              :label="item.label"
              :value="item.value"
              :active-values="modelValue"
              @change="changeItem"
            />
          </div>
        </NTabPane>
      </template>
    </NTabs>
    <div class="flex border-t-1 border-slate-2 px-sm pb-2 text-3.5 selected">
      <div class="flex-shrink-0 mr-4 mt-2">
        已选择:
      </div>
      <div>
        <!-- {{ selectedLabels }} -->
        <NTag v-for="v, i in selectedLabels" :key="i" closable class="mr-2 mt-2 rounded" @close="changeItem(modelValue[i])">
          {{ v }}
        </NTag>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>
